import type { Store } from '@geely/shared';
import { Calendar, Clock, MapPin } from 'lucide-react';
import { formatDate, formatTime } from '@/lib/utils';

interface AppointmentInfoSectionProps {
  store: Store;
  date: string;
  time: string;
}

export function AppointmentInfoSection({ store, date, time }: AppointmentInfoSectionProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-start gap-3">
        <MapPin className="size-5 text-gray-500 mt-0.5" />
        <div>
          <p className="font-medium">Loja</p>
          <p className="text-sm text-gray-600">{store.name}</p>
          <p className="text-sm text-gray-500">
            {store.street}, {store.number} - {store.neighborhood}, {store.city}
          </p>
        </div>
      </div>

      <div className="flex items-start gap-3">
        <Calendar className="size-5 text-gray-500 mt-0.5" />
        <div>
          <p className="font-medium">Data</p>
          <p className="text-sm text-gray-600">{formatDate(date)}</p>
        </div>
      </div>

      <div className="flex items-start gap-3">
        <Clock className="size-5 text-gray-500 mt-0.5" />
        <div>
          <p className="font-medium">Horário</p>
          <p className="text-sm text-gray-600">{formatTime(time)}</p>
        </div>
      </div>
    </div>
  );
}
